import { computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { or } from '@ember/object/computed';
import Controller from '@ember/controller';
import isDestroyed from 'cio/utils/is-destroyed';

export default class LayoutController extends Controller {
  @service apiErrors;
  @service router;

  @or('model.isUsed', 'model.isDefault') cannotDeleteLayout;

  // eslint-disable-next-line getter-return
  @computed('model.{isUsed,isDefault}')
  get reasonForPreventingDeletion() {
    let layout = this.model;

    if (layout.get('isDefault')) {
      return "You can't delete your default layout!";
    } else if (layout.get('isUsed')) {
      return "You can't delete a layout that's in use!";
    }
  }

  _deleteLayout() {
    let { model } = this;
    let promise = model.destroyRecord();

    this.apiErrors.attach(promise);

    promise
      .then(() => this.router.transitionTo('layouts'))
      .catch(() => {
        if (!isDestroyed(model)) {
          model.rollbackAttributes();
        }
      });

    return promise;
  }
}
